var exports = {
  "O": "x31de4314--e32643--rating",
};

module.exports = exports;
